<mat-form-field appearance="outline" [formGroup]="formGroup">
  <mat-label>{{placeholderText}}</mat-label>
  <input [matAutocomplete]="auto" matInput placeholder="{{placeholderText}}" formControlName="{{fieldName}}">
  <button type="button" color="primary" *ngIf="!loadingResults" mat-icon-button matSuffix (click)="searchPartyRoleSuite()" class="fmc-button-primary">
    <mat-icon>search</mat-icon>
  </button>
  <mat-spinner matSuffix [diameter]="20" [strokeWidth]="3" *ngIf="loadingResults"></mat-spinner>
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayName">
    <mat-option (click)="addParty()">+ Add a new {{placeholderText}}</mat-option>
    <mat-option *ngFor="let party of filteredPartyRoleSuites"[value]="party" (click)="updatedSelectedPrs(party)">
      <span>{{ party.PartyName }}</span>
    </mat-option>
  </mat-autocomplete>
  <mat-error>
    <app-validation-partial
        [formGroup]="formGroup"
        [fieldName]="fieldName"
    ></app-validation-partial>
  </mat-error>
</mat-form-field>
